import React, { useState, useMemo, useEffect } from 'react';
import { Row, Col } from 'tea-component';
import './LeaderBoard.scss';
import { useIntl, getLocale } from 'umi';
import moment from 'moment';
import { homeHonorTopCharts } from '@home/services/home';
import UserDefault from '@/pages/home/assets/img/common/user-default.svg';
import {setName} from "@home/pages/home/Explore/_config/common";
export default function TableAddonExample() {
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const isCN = locale == 'zh-CN';
  const quarter = useMemo(() => {
    // 获取当前日期的上一个季度
    let lastQuarter = moment().quarter() - 1;
    const currentYear = moment().year();
    let lastQuarterYear = currentYear;
    // 如果当前是第一季度，上一个季度应该是第四季度
    if (lastQuarter === 0) {
      lastQuarter = 4;
      lastQuarterYear = currentYear - 1; // 如果当前是第一季度，上一季度是去年的
    }
    const currentDate = moment();
    const currentQuarter = currentDate.quarter();
// 获取上一个季度
    let startMonth, endMonth;
    if (currentQuarter === 1) {
      // 如果当前是第一季度，则上一个季度是上一年的第四季度
      startMonth = 10;
      endMonth = 12;
    } else {
      // 否则上一个季度的起始月和结束月分别是当前季度起始月减3和当前季度起始月减1
      startMonth = (currentQuarter - 1) * 3 - 2;
      endMonth = (currentQuarter - 1) * 3;
    }

// 获取上一个季度的起始日期
    const startDate = moment({ year: currentDate.year() - (currentQuarter === 1 ? 1 : 0), month: startMonth - 1, day: 1 }).format('YYYY-MM-DD');

/// 获取上一个季度的结束日期
    const endDate = moment({ year: currentDate.year() - (currentQuarter === 1 ? 1 : 0), month: endMonth - 1 }).endOf('month').format('YYYY-MM-DD');
    return {
      lastQuarter,
      lastQuarterYear,
      startDate,
      endDate
    };
  }, []);
  const [authorsList, setAuthorsList] = useState([
    {
      id: 1,
      title: 'dbh_home_top_eye_catching_Authors',
      list: [],
      dataKey: 'Top Eye-Catching Authors',
      subTitle: 'dbh_home_report_views',
    },
    {
      id: 2,
      title: 'dbh_home_top_prolific_authors',
      list: [],
      dataKey: 'Top Prolific Authors',
      subTitle: 'dbh_home_report_articles',
    },
    {
      id: 3,
      title: 'dbh_home_top_active_data_lovers',
      list: [],
      dataKey: 'Top Active Data Lovers',
      subTitle: 'dbh_home_report_active_value',
    },
  ]);
  const getleaderData = async () => {
    const { startDate,endDate} = quarter;
    const res = await homeHonorTopCharts({
      'Top Eye-Catching Authors': {
        top: 3,
        report_types: ['intelligence_insights', 'intelligence_iic', 'gameResearch'],
        start_date: startDate,
        end_date: endDate,
      },
      'Top Prolific Authors': {
        top: 3,
        report_types: ['intelligence_insights', 'intelligence_iic', 'gameResearch'],
        start_date: startDate,
        end_date: endDate,
      },
      'Top Active Data Lovers': {
        top: 3,
        report_types: ['intelligence_insights', 'intelligence_iic', 'gameResearch'],
        start_date: startDate,
        end_date: endDate,
      },
    });
    const authorsListNew = authorsList.map((item) => {
      item.list = res[item.dataKey] || [];
      return item;
    });
    setAuthorsList(authorsListNew.slice(0));
  };
  useEffect(() => {
    getleaderData();
  }, []);
  const getUserDesc = (item: any, author: any) => {
    const isGameLoverData = item.dataKey === 'Top Active Data Lovers';
    const localeEndStr = isCN ? 'cn' : 'en';
    const strStart = isGameLoverData ? 'creator_department_' : 'title_';
    return author[`${strStart}${localeEndStr}`];
  };
  return (
    <div className="dbh-leaderboard">
      <div className="dbh-leaderboard-hd">
        <div className="dbh-leaderboard-title">
          {formatMessage({ id: 'dbh_home_game_data_lover_leaderboard' })} -{' '}
          {quarter?.lastQuarterYear} {quarter?.lastQuarter ? `Q${quarter.lastQuarter}` : ''}
        </div>
        <div className="dbh-leaderboard-title-shadow --shadow">
          {formatMessage({ id: 'dbh_home_game_data_lover_leaderboard' })} -{' '}
          {quarter?.lastQuarterYear} {quarter?.lastQuarter ? `Q${quarter.lastQuarter}` : ''}
        </div>
      </div>
      <div className="dbh-leaderboard-bd">
        <Row>
          {authorsList.map((item) => (
            <Col span={8}>
              <div className="dbh-top-authors">
                <div className="dbh-top-authors-hd">
                  <div className="dbh-top-authors-title">
                    <span>{formatMessage({ id: item.title })}</span>
                  </div>
                  <i className="icon-leaderboard-before"></i>
                </div>
                <div className="dbh-top-authors-bd">
                  <div className="dbh-top-authors-list">
                    {item?.list?.length
                      ? item?.list?.map((author:any, idx) => (
                          <div className="dbh-top-authors-card" key={author.id}>
                            <div className="dbh-top-authors-avatar">
                              <i className="--before"></i>
                              <img src={author.create_head_picture || UserDefault} />
                              <span className="dbh-top-authors-avatar-num">{idx + 1}</span>
                            </div>
                            <div className="dbh-top-authors-content">
                              <div className="dbh-top-authors-name">{setName(author.create_name_cn)}</div>
                              <div className="dbh-top-authors-view">
                                <div className="dbh-top-authors-view-inner">
                                  <span className="dbh-top-authors-view-title">
                                    {formatMessage({ id: item?.subTitle })}
                                  </span>
                                  <span className="dbh-top-authors-view-num">
                                    {item.dataKey === 'Top Prolific Authors'
                                      ? author?.total_num
                                      : author?.total_pv || '-'}
                                  </span>
                                </div>
                              </div>
                              <div className="dbh-top-authors-team">
                                {getUserDesc(item, author)}
                              </div>
                            </div>
                          </div>
                        ))
                      : null}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
